import { BACKEND_URL } from 'AppSettings'
import ImageFallback from 'components/molecules/ImageFallback'
import React from 'react'
import './styles.scss'

interface AvatarProps {
  icon?: string | null
  name: string
  email: string | null
}

const Avatar = ({ icon, name, email }: AvatarProps): JSX.Element => {
  const renderIcon = () => {
    if (icon) {
      return (
        <ImageFallback
          className='img-avatar'
          src={BACKEND_URL + icon}
          alt={name}
          fallback={
            <div className='text-avatar'>
              <span className='letter'>{name.trim().charAt(0)}</span>{' '}
            </div>
          }
        />
      )
    }

    return (
      <div className='text-avatar'>
        <span className='letter'>{name.trim().charAt(0)}</span>{' '}
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className='avatar'>
        <div>{renderIcon()}</div>
        <div>
          <span className='avatar-name'>{name}</span>
          <div>
            <a href={`mailto:${email}`}>{email}</a>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Avatar
